import React from 'react';
import { FaEdit, FaClone, FaTrash, FaLayerGroup, FaBriefcase, FaFilm, FaUsers } from 'react-icons/fa';

const formatCamelCase = (text) => {
  if (!text) return "";
  return text
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, char => char.toUpperCase());
};

const RolesMobileCard = ({ role, handleEdit, handleClone, handleDelete, hasPermission }) => {
  const isInactive = String(role.status).toLowerCase() === 'inactive';

  return (
    <div key={role.id} className="project-mobile-card mb-3">
      <div className="d-flex justify-content-between align-items-start mb-2">
        <h6 className="project-card-title m-0 text-white fw-bold">{role.roleName}</h6>
        <span className={`mrp-status-tag ${isInactive ? 'mrp-status-inactive' : 'mrp-status-active'}`}>
          {role.status}
        </span>
      </div>

      <div className="card-data-grid mt-2 mb-2">
        <div className="data-item">
          <FaFilm className="text-danger" />
          <span className="lbl">Project:</span>
          <span className="val text-truncate" style={{ maxWidth: '110px' }}>{role.projectName}</span>
        </div>
        <div className="data-item">
          <FaLayerGroup className="text-info" />
          <span className="lbl">Category:</span>
          <span className="val text-truncate">{formatCamelCase(role.roleCategory)}</span>
        </div>
        <div className="data-item">
          <FaBriefcase className="text-success" />
          <span className="lbl">Mode:</span>
          <span className="val text-truncate">{formatCamelCase(role.auditionType)}</span>
        </div>
        <div className="data-item">
          <FaUsers className="text-warning" />
          <span className="lbl">Applicants:</span>
          <span className="val fw-bold">{role.totalApplicants || 0}</span>
        </div>
      </div>

      <hr className="compact-hr my-2" />

      <div className="d-flex justify-content-between align-items-center">
        <div className="house-data">
          <span className="house-name-gold">Selected: {role.selectedCount || 0}</span>
        </div>
        <div className="mrp-action-btn-group d-flex gap-2">
          {hasPermission('Roles', 'Edit') && (
            <button 
              type="button" 
              className="mrp-btn-action mrp-btn-edit" 
              onClick={() => handleEdit(role.id)}
              title="Edit Role"
            >
              <FaEdit size={13} color="#ffffff" />
            </button>
          )}
          {hasPermission('Roles', 'Clone') && (
            <button 
              type="button" 
              className="mrp-btn-action mrp-btn-clone" 
              onClick={() => handleClone(role)}
              title="Clone Role"
            >
              <FaClone size={13} color="#ffffff" />
            </button>
          )}
          {hasPermission('Roles', 'Delete') && (
            <button 
              type="button" 
              className="mrp-btn-action mrp-btn-delete" 
              onClick={() => handleDelete(role)}
              title="Delete Role"
            >
              <FaTrash size={13} color="#ffffff" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RolesMobileCard;
